module.exports = __webpack_public_path__ + "media/img/venue-icon-00ed25d60f6f70a95a0d888168b32034.png";